import React, { Suspense } from 'react';
import { ProgressIndicator } from '@fluentui/react/lib/ProgressIndicator';
import ModalContext from '../Context/ModalContext';
import { alternateFullScreenModalStyle } from './Styles';
import FluentModal from './FluentModal';

const LazySupplierReturnForm = React.lazy(() => import('../../views/purchases/SupplierReturnForm'));

const SupplierReturnFormModal = ({
  closeModal,
  activeTabId,
  onChange,
  modalState: { modalOpen: isOpen, uuid: newSupplierReturnUuid, initialValues } = { modalOpen: false },
  readOnly = false,
}: {
  closeModal: (values?: any) => void;
  activeTabId?: string;
  onChange?: Function;
  modalState: { modalOpen: boolean; uuid?: string; initialValues?: any };
  readOnly?: boolean;
}) => {
  return (
    <ModalContext.Provider
      value={{
        onClose: closeModal,
        style: alternateFullScreenModalStyle,
        tabStyles: { container: { height: '600px', width: '80vw' } },
      }}
    >
      <FluentModal
        isOpen={isOpen}
        onDismiss={closeModal}
        styles={{
          main: {
            minWidth: '400px',
            overflowY: 'unset',
          },
        }}
      >
        <Suspense fallback={<ProgressIndicator />}>
          <LazySupplierReturnForm
            modalClose={true}
            onClose={closeModal}
            temporaryOnChange={true}
            initialized={true}
            isOpen={isOpen}
            closeModal={closeModal}
            readOnly={readOnly}
            onChange={onChange}
            temporaryDefault={true}
            activeTabId={activeTabId}
            overrideParams={{ uuid: newSupplierReturnUuid }}
            formData={{ defaultRecord: initialValues }}
          />
        </Suspense>
      </FluentModal>
    </ModalContext.Provider>
  );
};

export default SupplierReturnFormModal;
